import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  allData: [],
  stores: [],
  users: [],
  sessionAudits: [],
  auditList: [],
  searchEntity: null,
  selectedOption: {
    user: "",
    store: "",
    session_audit: "",
  },
  selectedType: "category",
  selectedAudit: "",
  selectedCategory: "",
  selectedStore: "",
  isLoading: false,
  error: false,
  activeProjectIC: null,
};

const imageVCSlice = createSlice({
  name: "imageViewerLikeContext",
  initialState,
  reducers: {
    setLoading: (state, action) => {
      state.isLoading = action.payload;
    },
    setAllData: (state, action) => {
      state.allData = action.payload;
    },
    setStoreData: (state, action) => {
      state.stores = action.payload;
    },
    setUserData: (state, action) => {
      state.users = action.payload;
    },
    setSessionAuditData: (state, action) => {
      state.sessionAudits = action.payload;
    },
    setAuditList: (state, action) => {
      state.auditList = action.payload;
    },
    setSelectedType(state, action) {
      state.selectedType = action.payload;
    },
    setAuditId: (state, action) => {
      state.selectedAudit = action.payload;
    },
    getDataFailure: (state) => {
      state.isLoading = false;
      state.error = true;
    },
    getDataEnd: (state) => {
      state.isLoading = false;
    },
    setSelectedOption: (state, action) => {
      state.selectedOption = action.payload;
    },
    resetDefaultTabStateToDefaultImg(state, action) {
      const updatedState = { ...state, ...initialState };
      return updatedState;
    },
    setActiveProjectIC: (state, action) => {
      state.activeProjectIC = action.payload;
    },
    setSearchEntity: (state, action) => {
      state.searchEntity = action.payload;
    },
    setSelectedCategory: (state, action) => {
      state.selectedCategory = action.payload;
    },
    setSelectedStore: (state, action) => {
      state.selectedStore = action.payload;
    },
  },
});

export const {
  setLoading,
  isLoading,
  setSelectedOption,
  setSelectedCategory,
  setSelectedStore,
  setSearchEntity,
  searchEntity,
  setActiveProjectIC,
  resetDefaultTabStateToDefaultImg,
  getDataFailure,
  getDataEnd,
  setStoreData,
  setSessionAuditData,
  setUserData,
  setAllData,
  setAuditList,
  setSelectedType,
  selectedType,
  setAuditId,
  selectedAudit,
} = imageVCSlice.actions;

export default imageVCSlice.reducer;
